import jwtMixin from './jwtMixin'
import utilitiesMixin from './utilitiesMixin'

const SAVE_INTERVAL_MS = 12000

export default {
  // utilitiesMixin se declara aquí, y no solo en el componente, para que recordingPercentage
  // esté garantizado allí donde se use este mixin.
  mixins: [jwtMixin, utilitiesMixin],
  props: ['recording'],
  data () {
    return {
      resumeSaveTimer: null,
      resumeLastSentMs: null,
      pendingResumeFields: null,
      resumeInFlight: false
    }
  },
  watch: {
    player: function (player) {
      if (player) {
        player.on('loadedmetadata', this.applyResumePosition)
        player.on('play', this.onResumePlay)
        player.on('pause', this.saveResumePosition)
        player.on('seeked', this.saveResumePosition)
        player.on('ended', this.onResumeEnded)
      }
    }
  },
  beforeDestroy () {
    this.stopResumeSaveTimer()
    this.saveResumePosition()
  },
  methods: {
    applyResumePosition () {
      if (this.recording && this.recording.lastPositionMs) {
        this.player.currentTime(this.recording.lastPositionMs / 1000)
      }
    },
    onResumePlay () {
      if (!this.recording) return
      if (!this.recording.playing) {
        this.syncRecordingState({ playing: true })
        this.patchResume({ playing: true })
      }
      if (!this.resumeSaveTimer) {
        this.resumeSaveTimer = setInterval(this.saveResumePosition, SAVE_INTERVAL_MS)
      }
    },
    onResumeEnded () {
      this.stopResumeSaveTimer()
      if (!this.recording) return
      const durationMs = Math.round(this.player.duration() * 1000)
      this.syncRecordingState({ lastPositionMs: durationMs, percentage: 100, playing: false, viewed: true })
      this.patchResume({ playing: false, lastPositionMs: durationMs, viewed: true })
    },
    saveResumePosition () {
      if (!this.player || !this.recording) return
      const positionMs = Math.round(this.player.currentTime() * 1000)
      if (positionMs === this.resumeLastSentMs) return
      this.resumeLastSentMs = positionMs
      this.syncRecordingState({ lastPositionMs: positionMs, percentage: this.resumePercentage(positionMs) })
      this.patchResume({ lastPositionMs: positionMs })
    },
    resumePercentage (positionMs) {
      const percentage = this.recordingPercentage(positionMs, this.recording.duration)
      return percentage === null ? this.recording.percentage : percentage
    },
    syncRecordingState (fields) {
      // Actualiza el objeto local (misma referencia que la lista desde la que se lanzó) y
      // emite el cambio para que el contenedor sincronice el resto de copias en memoria de la
      // misma grabación: la card de "Seguir viendo" y la del listado son objetos distintos
      // (provienen de llamadas diferentes) y ambas deben reflejar el mismo progreso/estado
      Object.keys(fields).forEach(k => { this.recording[k] = fields[k] })
      this.$emit('recording-progress', { recordingId: this.recording.id, ...fields })
    },
    stopResumeSaveTimer () {
      if (this.resumeSaveTimer) {
        clearInterval(this.resumeSaveTimer)
        this.resumeSaveTimer = null
      }
    },
    patchResume (fields) {
      // Acumulamos los campos en un buffer y disparamos el envío. flushResumePatch
      // garantiza que solo haya un PATCH en vuelo a la vez sobre este registro.
      this.pendingResumeFields = { ...this.pendingResumeFields, ...fields }
      this.flushResumePatch()
    },
    flushResumePatch () {
      // Si ya hay una petición en vuelo no lanzamos otra: los campos quedan en el
      // buffer y se enviarán en cuanto la actual termine. Así evitamos peticiones
      // solapadas que el backend resolvería con read-modify-write pisándose entre sí
      // (p.ej. lastPositionMs del 'seeked' de reanudación y playing/viewed del 'ended').
      if (this.resumeInFlight || !this.pendingResumeFields || !this.recording) return
      const fields = this.pendingResumeFields
      this.pendingResumeFields = null
      this.resumeInFlight = true
      const userId = this.jwtLoggedUserId()
      const onDone = () => {
        this.resumeInFlight = false
        // Reenviamos lo que se haya acumulado mientras la petición estaba en vuelo
        this.flushResumePatch()
      }
      // background: true -> sin overlay de carga ni toast de error (ver los interceptores de
      // App.vue). Esto se dispara cada 12s con el vídeo en marcha: el usuario no ha pedido
      // nada y no debe notarlo. El rechazo lo absorbe el onDone del segundo argumento.
      return window.axios.patch('recordings/' + this.recording.id + '/user/' + userId, {
        recordingId: this.recording.id,
        userId,
        ...fields
      }, { background: true }).then(onDone, onDone)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/videoResumeMixin.js